import { Turbo } from "@hotwired/turbo-rails"

window.Turbo = Turbo
